(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = () => {
    document.querySelectorAll('[data-ycn-hero]').forEach(player => {
      if (player.dataset.initialized) return;
      player.dataset.initialized = 'true';
      const video = player.querySelector('video');
      const button = player.querySelector('.ycn-hero-play');
      video.addEventListener('playing', () => player.setAttribute('data-video-playing', ''));
      video.addEventListener('error', () => { player.removeAttribute('data-video-playing'); button.hidden = false; });
      const mobile = window.matchMedia('(max-width: 699px)').matches;
      const start = () => {
        if (!video.getAttribute('src')) video.src = mobile ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (mobile) video.controls = true;
        video.play().then(() => { button.hidden = true; }).catch(() => { button.hidden = false; });
      };
      button.addEventListener('click', event => { event.stopPropagation(); start(); });
      if (!mobile) {
        player.setAttribute('autoplay', '');
        start();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ycn-attributed-quote"] && !Shopify.designMode) return;
  try {
    
const showYachtContext = () => {
  const params = new URLSearchParams(window.location.search);
  const name = (params.get('yacht_name') || '').trim();
  const id = (params.get('yacht') || '').trim();
  if (!name || name.length > 160 || !/^[A-Za-z0-9_-]{1,80}$/.test(id)) return;
  document.querySelectorAll('[data-yacht-context]').forEach(context => {
    context.querySelector('[data-yacht-name]').textContent = name;
    context.hidden = false;
  });
};
showYachtContext();
document.addEventListener('shopify:section:load', showYachtContext);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ycn-charter-calculator"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ycn-charter-calculator')) {
  class YcnCharterCalculator extends HTMLElement {
    static guideRates(length, year) {
      if (!(length > 0) || !(year > 0) || length > 100) return null;
      const band = length < 50 ? 0 : length < 70 ? 1 : length < 85 ? 2 : 3;
      const day = (year >= 2020 ? [[2500,3000,3500],[3000,3500,4000],[4000,5000,6000],[6000,7000,8000]] : [[2000,2500,3000],[2500,3000,3500],[3500,4500,5500],[4500,5500,6500]])[band];
      const term = length < 50 ? 25000 : length < 60 ? 30000 : length < 70 ? 35000 : length < 80 ? 42000 : length < 90 ? 55000 : 80000;
      return { day, term };
    }
    static estimate(d, p) {
      const n = x => Number.isFinite(Number(x)) ? Math.max(0, Number(x)) : 0;
      const length = n(d.length);
      const months = Math.min(12, Math.max(1, n(d.months)));
      const count = [4, 6, 8].reduce((s, h) => s + n(d['count' + h]), 0);
      const gross = [4, 6, 8].reduce((s, h) => s + n(d['count' + h]) * n(d['rate' + h]), 0);
      const commission = gross * Math.min(100, n(p.charter_margin)) / 100;
      const management = length < 50 ? n(p.management_1) : length < 70 ? n(p.management_2) : length < 90 ? n(p.management_3) : n(p.management_4);
      const dockage = d.dockage === 'private' ? length * n(p.private_rate) : d.dockage === 'marina' ? length * n(p.marina_rate) : 0;
      const utilities = d.dockage === 'marina' ? n(d.utilities) : 0;
      const exterior = d.exterior ? length * n(p.exterior_rate) * n(d.exterior_count) : 0;
      const interior = d.interior ? n(p.interior_rate) * n(p.interior_hours) * n(d.interior_count) : 0;
      const bottom = d.bottom ? length * n(p.bottom_rate) * n(p.bottom_frequency) : 0;
      const ac = d.ac ? n(p.ac_price) / Math.max(1, n(p.ac_interval)) : 0;
      const insurance = n(d.insurance) / 12;
      const maintenance = n(d.maintenance) / 12;
      const other_fixed = n(d.other_fixed);
      const loan = n(d.loan);
      const fixed = management + dockage + utilities + exterior + interior + bottom + ac + insurance + maintenance + other_fixed;
      const annual_day_gross = gross * months;
      const term_weeks = n(d.term_count) * n(d.term_weeks);
      const annual_term_gross = term_weeks * n(d.term_rate);
      const annual_gross = annual_day_gross + annual_term_gross;
      const margin = Math.min(100, n(p.charter_margin)) / 100;
      const annual_commission = annual_gross * margin;
      const annual_receipts = annual_gross - annual_commission;
      const day_hours = [4,6,8].reduce((sum,h) => sum + h * n(d['count'+h]), 0) * months;
      const annual_day_captain = day_hours * n(p.captain_hourly);
      const annual_day_stew = day_hours * n(p.stew_hourly);
      const annual_term_captain = term_weeks * n(p.captain_weekly);
      const annual_term_stew = term_weeks * n(p.stew_weekly);
      const annual_day_crew = annual_day_captain + annual_day_stew;
      const annual_term_crew = annual_term_captain + annual_term_stew;
      const annual_crew = annual_day_crew + annual_term_crew;
      const annual_variable = term_weeks * n(d.term_variable);
      const annual_fixed = fixed * 12;
      const annual_debt = loan * 12;
      const annual_cash = annual_receipts - annual_variable - annual_crew - annual_fixed - annual_debt;
      const contribution = count > 0 ? (gross - commission) / count - annual_day_crew / (count * months) : 0;
      const coverage = annual_fixed + annual_debt > 0 ? (annual_receipts - annual_variable - annual_crew) / (annual_fixed + annual_debt) * 100 : null;
      const remaining = Math.max(0, annual_fixed + annual_debt - (annual_term_gross * (1 - margin) - term_weeks * n(d.term_variable) - annual_term_crew));
      const break_even = remaining === 0 ? 0 : count === 0 ? null : contribution <= 0 ? Infinity : Math.ceil(remaining / (months * contribution));
      return { annual_day_captain, annual_day_stew, annual_term_captain, annual_term_stew, annual_crew, annual_day_gross, annual_term_gross, term_weeks, management, dockage, utilities, exterior, interior, bottom, ac, insurance, maintenance, other_fixed, loan, annual_gross, annual_commission, annual_receipts, annual_variable, annual_fixed, annual_debt, annual_cash, monthly_cash: annual_cash / 12, monthly_budget: fixed + loan, coverage, break_even, count };
    }
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD',maximumFractionDigits:0});
      this.preciseMoney = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD',minimumFractionDigits:2,maximumFractionDigits:2});
      this.p = {};
      for (const [k,v] of Object.entries(this.dataset)) this.p[k.replace(/-/g, '_').replace(/[A-Z]/g, x => '_' + x.toLowerCase())] = Number(v);
      this.messages = {};
      this.querySelector('template[data-messages]').content.querySelectorAll('[data-message]').forEach(e => this.messages[e.dataset.message] = e.textContent);
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('change', () => this.update());
      this.form.addEventListener('submit', e => e.preventDefault());
      this.form.addEventListener('reset', () => queueMicrotask(() => this.update()));
      this.update();
    }
    update() {
      const get = name => this.form.elements.namedItem(name);
      get('utilities').disabled = get('dockage').value !== 'marina';
      get('exterior_count').disabled = !get('exterior').checked;
      get('interior_count').disabled = !get('interior').checked;
      const guide = YcnCharterCalculator.guideRates(Number(get('length').value), Number(get('year').value));
      const auto = get('rate_mode').value === 'guide';
      [4,6,8].forEach((h,i) => {
        get('rate'+h).readOnly = auto;
        if (auto) get('rate'+h).value = guide ? guide.day[i] : '';
      });
      get('term_rate').readOnly = auto;
      if (auto) get('term_rate').value = guide ? guide.term : '';
      let valid = true;
      const d = {};
      for (const e of this.form.elements) {
        if (!e.name) continue;
        const ok = e.disabled || e.validity.valid;
        e.setAttribute('aria-invalid', String(!ok));
        valid = valid && ok;
        d[e.name] = e.type === 'checkbox' ? e.checked : e.value;
      }
      if (!(Number(d.length) > 0)) { valid = false; get('length').setAttribute('aria-invalid','true'); }
      if (!(Number(d.year) > 0)) { valid = false; get('year').setAttribute('aria-invalid','true'); }
      if (!(Number(d.term_weeks) >= 1) || Number(d.term_count) * Number(d.term_weeks) > 52) { valid = false; get('term_weeks').setAttribute('aria-invalid','true'); }
      if (!valid || (auto && !guide)) {
        this.querySelectorAll('[data-out]').forEach(e => e.textContent = '—');
        this.querySelector('[data-status]').textContent = valid ? this.messages.unsupported : this.messages.invalid;
        this.querySelector('.ycn-results').dataset.negative = 'false';
        return;
      }
      const mixTotal = [4,6,8].reduce((sum,h) => sum + Number(d['share'+h] || 0), 0);
      if (mixTotal <= 0 && Number(d.day_count) > 0) {
        [4,6,8].forEach(h => get('share'+h).setAttribute('aria-invalid','true'));
        this.querySelectorAll('[data-out]').forEach(e => e.textContent = '—');
        this.querySelector('[data-status]').textContent = this.messages.mix_error;
        this.querySelector('.ycn-results').dataset.negative = 'false';
        return;
      }
      [4,6,8].forEach(h => d['count'+h] = mixTotal > 0 ? Number(d.day_count) * Number(d['share'+h] || 0) / mixTotal : 0);
      const r = YcnCharterCalculator.estimate(d, this.p);
      const hasRates = [4,6,8].some(h => Number(d['rate' + h]) > 0) || Number(d.term_rate) > 0;
      this.querySelectorAll('[data-out]').forEach(e => {
        const key = e.dataset.out;
        if (!hasRates && ['annual_cash','monthly_cash','coverage'].includes(key)) e.textContent = '—';
        else if (key === 'break_even') e.textContent = r[key] === null ? this.messages.no_mix : r[key] === Infinity ? this.messages.no_margin : String(r[key]);
        else if (key === 'count') e.textContent = String(r.count);
        else if (key === 'coverage') e.textContent = r[key] === null ? this.messages.na : Math.round(r[key]) + '%';
        else e.textContent = key === 'monthly_budget' || key === 'ac' ? this.preciseMoney.format(r[key]) : this.money.format(r[key]);
      });
      this.querySelector('[data-status]').textContent = r.annual_gross > 0 ? this.messages.partial : this.messages.notice;
      this.querySelector('.ycn-results').dataset.negative = String(hasRates && r.annual_cash < 0);
    }
  }
  customElements.define('ycn-charter-calculator', YcnCharterCalculator);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ycn-location-yachts"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ycn-location-inventory')) {
  customElements.define('ycn-location-inventory', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || this.initialize()) return;
      this.pendingObserver = new MutationObserver(() => {
        if (this.initialize()) {
          this.pendingObserver.disconnect();
          this.pendingObserver = null;
        }
      });
      this.pendingObserver.observe(this, { childList: true, subtree: true });
    }
    disconnectedCallback() {
      if (this.pendingObserver) this.pendingObserver.disconnect();
      this.pendingObserver = null;
    }
    initialize() {
      if (this.ready) return true;
      const grid = this.querySelector('product-list');
      const complete = this.querySelector('[data-ycn-inventory-complete]');
      if (!complete) return false;
      if (!grid) return true;
      const pageSize = Number(this.dataset.pageSize) || 18;
      let currentPage = 1;
      const pageNav = this.querySelector('[data-ycn-pagination]');
      const cards = [...grid.querySelectorAll(':scope > product-card')];
      const form = this.querySelector('[data-ycn-filters]');
      const dialog = this.querySelector('dialog');
      const sort = this.querySelector('[data-ycn-sort]');
      const open = this.querySelector('[data-ycn-open]');
      const error = this.querySelector('[data-ycn-filter-error]');
      const sizeFields = this.querySelector('[data-ycn-size-fields]');
      if (!pageNav || !form || !dialog || !sort || !open || !error || !sizeFields) return false;
      this.ready = true;
      sizeFields.hidden = !cards.some(card => Number(card.dataset.ycnSize) > 0);
      this.querySelector('[data-ycn-controls]').hidden = false;
      let active = new FormData(form);
      const range = (data, key, fallback) => data.get(key) === '' || data.get(key) === null ? fallback : Number(data.get(key));
      const apply = () => {
        const min = range(active, 'min_price', 0) * 100;
        const max = range(active, 'max_price', Infinity) * 100;
        const minSize = range(active, 'min_size', 0);
        const maxSize = range(active, 'max_size', Infinity);
        const types = active.getAll('yacht_type');
        const sorted = [...cards];
        if (sort.value.startsWith('price')) sorted.sort((a,b) => Number(a.dataset.ycnPrice) - Number(b.dataset.ycnPrice));
        if (sort.value.startsWith('title')) sorted.sort((a,b) => a.dataset.ycnTitle.localeCompare(b.dataset.ycnTitle));
        if (sort.value.endsWith('descending')) sorted.reverse();
        const matched = sorted.filter(card => {
          const price = Number(card.dataset.ycnPrice);
          const size = Number(card.dataset.ycnSize);
          const sizeMatch = minSize === 0 && maxSize === Infinity || size > 0 && size >= minSize && size <= maxSize;
          return price >= min && price <= max && sizeMatch && (!types.length || types.includes(card.dataset.ycnType));
        });
        const count = matched.length;
        const pageCount = Math.ceil(count / pageSize);
        currentPage = Math.min(currentPage, pageCount || 1);
        const visible = new Set(matched.slice((currentPage - 1) * pageSize, currentPage * pageSize));
        sorted.forEach(card => { card.hidden = !visible.has(card); grid.append(card); });
        pageNav.replaceChildren();
        pageNav.hidden = pageCount <= 1;
        for (let page = 1; page <= pageCount; page++) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pagination__link';
          button.textContent = String(page);
          button.setAttribute('aria-label', `Go to page ${page}`);
          if (page === currentPage) button.setAttribute('aria-current', 'page');
          button.addEventListener('click', () => { currentPage = page; apply(); this.scrollIntoView({block:'start'}); });
          pageNav.append(button);
        }
        this.querySelector('[data-ycn-count]').textContent = `${count} ${count === 1 ? 'yacht' : 'yachts'}`;
        this.querySelector('[data-ycn-empty]').hidden = count !== 0;
        grid.hidden = count === 0;
        open.classList.toggle('is-active', min > 0 || max < Infinity || minSize > 0 || maxSize < Infinity || types.length > 0);
      };
      open.addEventListener('click', () => dialog.showModal());
      this.querySelector('[data-ycn-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => open.focus());
      sort.addEventListener('change', () => { currentPage = 1; apply(); });
      form.addEventListener('submit', event => {
        event.preventDefault();
        const data = new FormData(form);
        const invalid = range(data,'min_price',0) > range(data,'max_price',Infinity) || range(data,'min_size',0) > range(data,'max_size',Infinity);
        error.hidden = !invalid;
        if (invalid) return;
        currentPage = 1;
        active = data;
        apply();
        dialog.close();
      });
      form.addEventListener('reset', () => {
        currentPage = 1;
        active = new FormData();
        error.hidden = true;
        apply();
      });
      apply();
      return true;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
